export const ACCEPTABLE_HEADERS = {
  'NEW Account Lead': [
    'NEW Account Lead','newAccountLead'
  ],
  'NEW Account Lead Email':[
    'NEW Account Lead Email','email','newAccountLeadEmail'
  ],
  'OLD Account Lead':[
    'OLD Account Lead','oldAccountLead'
  ],
  'Reseller FSAP':[
    'Reseller FSAP','resellerFSAP'
  ],
  'Reseller Name':[
    'Reseller Name','resellerName'
  ]
}

export const REQUIRED_HEADERS = [
  'NEW Account Lead Email' ,'Reseller FSAP'
]


export const headerCell = value => {
  return (
    <div key={value} className='cell df aic'>
      <span>{value}</span>
    </div>
  )
}

export const initStructure = {
  headers: [
    {
      value: 'NEW Account Lead',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'NEW Account Lead Email',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'OLD Account Lead',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Reseller FSAP',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Reseller Name',
      format() {
        return headerCell(this.value)
      }
    }
  ]
}
